// extracted by mini-css-extract-plugin
export default {"backInStockButton":"zW6LYz","primaryButton":"j8uWA0","fullWidth":"m93aEz"};